import { RequestParams, ResponseCatalog } from 'Models'
import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { RecommendationModel, ProductModel } from 'Pages/orders'
import { BusinessappsOrdersModel } from 'Pages/orders_design'

async function getItems(requestParams: RequestParams) {
	const res = await axiosDS().get<ResponseCatalog<ProductModel>>(urls.orders.products, {
		params: requestParams,
	})
	return res.data
}

async function getRecommendation(query: string) {
	const res = await axiosDS().get<ResponseCatalog<RecommendationModel>>(
		`${urls.orders.products_recommendations}`,
		{
			params: { query },
		}
	)
	return res.data
}

async function getBusinessapps(inn: string) {
	const res = await axiosDS().get<BusinessappsOrdersModel>(`${urls.orders.show_businessapp}`, {
		params: { inn },
	})
	return res.data
}

export const productApi = {
	getItems,
	getRecommendation,
	getBusinessapps,
}
